import {Component, inject} from '@angular/core';
import {FarmStore} from 'src/app/domain/assets/farm/farm.store';

@Component({
  selector: 'app-weather-widget',
  imports: [],
  templateUrl: './weather-widget.component.html',
  styleUrl: './weather-widget.component.css'
})
export class WeatherWidgetComponent {

  farmStore = inject(FarmStore);
}
